import { getEventDateText } from '../../../organisms/event-card/utils'
import type { GetEventAlertTitleProps } from './types'

export const getEventAlertTitle = ({ event, t, locale }: GetEventAlertTitleProps) => {
  const { startDate, endDate } = event

  return t('absenceRequest.new.absenceBlockerAlert.title', {
    dateRange: getEventDateText({ event, startDate, endDate, locale, t }),
  })
}
